import axios from 'axios';
import Cookies from 'js-cookie';

export const SESSION_EXPIRED_EVENT = 'sccc:session-expired';

const AUTH_FAILURE_MESSAGE_PATTERNS = [
  /failed to authenticate token/i,
  /no token provided/i,
];

const AUTH_EXEMPT_URL_PATTERNS = [/\/api\/userLogin(\b|\/)/i, /\/api\/userLogout(\b|\/)/i];

const AUTH_PAGE_PATH_PATTERNS = [
  /^\/admin\/?$/i,
  /^\/memberLogin(\/|$)/i,
  /^\/adminForgotPassword\/?$/i,
  /^\/memberForgotPassword\/?$/i,
  /^\/resetPassword(\/|$)/i,
  /^\/preRegistration(\/|$)/i,
];

let sessionExpiredDispatched = false;
let interceptorInstalled = false;

const isAuthExemptUrl = (url) => {
  if (!url) {
    return false;
  }
  return AUTH_EXEMPT_URL_PATTERNS.some((pattern) => pattern.test(url));
};

const extractMessage = (data) => {
  if (!data) {
    return '';
  }
  if (typeof data === 'string') {
    return data;
  }
  if (typeof data === 'object') {
    return data.message || data.error || data.errorMessage || '';
  }
  return '';
};

const matchesAuthFailureMessage = (message) => {
  if (!message || typeof message !== 'string') {
    return false;
  }
  return AUTH_FAILURE_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
};

const isAuthFailureResponse = (response) => {
  if (!response) {
    return false;
  }
  const { status, data } = response;
  if (status === 401 || status === 403) {
    return true;
  }
  if (status === 500) {
    return matchesAuthFailureMessage(extractMessage(data));
  }
  return false;
};

const getRequestUrl = (error) => {
  if (!error) {
    return '';
  }
  if (error.config && error.config.url) {
    return error.config.url;
  }
  if (error.response && error.response.config && error.response.config.url) {
    return error.response.config.url;
  }
  return '';
};

const hasSessionToken = () => !!Cookies.get('token');

const isAuthPage = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return AUTH_PAGE_PATH_PATTERNS.some((pattern) => pattern.test(window.location.pathname));
};

export const triggerSessionExpired = () => {
  if (sessionExpiredDispatched) {
    return;
  }
  sessionExpiredDispatched = true;

  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.clear();
    }
  } catch (e) {
    // ignore storage clear failures
  }

  Cookies.remove('token');
  Cookies.remove('userInfo');

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
  }
};

export const resetSessionExpiredGuard = () => {
  sessionExpiredDispatched = false;
};

export const installAuthInterceptor = () => {
  if (interceptorInstalled) {
    return;
  }
  interceptorInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const requestUrl = getRequestUrl(error);
      if (hasSessionToken() && !isAuthPage() && !isAuthExemptUrl(requestUrl) && isAuthFailureResponse(error && error.response)) {
        triggerSessionExpired();
      }
      return Promise.reject(error);
    }
  );
};

export default installAuthInterceptor;
